<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">

                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form id="question41Form" method="POST" :action="this.action" accept-charset="UTF-8"
                            enctype="multipart/form-data" class="workflow-tabs">

                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">

                            <input type="hidden" class="form-control" name="questionBase[name]" v-model="name" />
                            <input type="hidden" class="form-control" name="questionBase[description]"
                                v-model="description" />
                            <input type="hidden" class="form-control" name="questionBase[sorting]" v-model="sorting" />

                            <ul class="nav nav-tabs" id="targetConf" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="step-1" data-toggle="tab"
                                        data-target="#baseConfStep" type="button" role="tab"
                                        aria-controls="baseConfStep" aria-selected="true" @click="updateOldStep(1)">
                                        {{
                                            __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_1")
                                        }}
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="step-2" data-toggle="tab" data-target="#categoriesStep"
                                        type="button" @click="updateOldStep(2)" role="tab"
                                        aria-controls="categoriesStep" aria-selected="false">
                                        {{
                                            __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_2")
                                        }}
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="step-3" data-toggle="tab"
                                        data-target="#historiesSkillsStep" type="button" @click="updateOldStep(3)"
                                        role="tab" aria-controls="historiesSkillsStep" aria-selected="false">
                                        {{
                                            __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_3")
                                        }}
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="step-4" data-toggle="tab" data-target="#levelsStep"
                                        type="button" @click="updateOldStep(4)" role="tab" aria-controls="levelsStep"
                                        aria-selected="false">
                                        {{
                                            __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_4")
                                        }}
                                    </button>
                                </li>
                                <!-- SlideShow Coming soon -->
                                <!-- <li class="nav-item" role="presentation">
                                    <button 
                                        class="nav-link"
                                        id="step-5"
                                        data-toggle="tab"
                                        data-target="#slideModeStep"
                                        type="button"
                                        @click="updateOldStep(5)"
                                        role="tab" 
                                        aria-controls="slideModeStep"
                                        aria-selected="false">
                                        {{__("forms.EvaluationChart.questions.questions_setting.question41.steps.step_5")}}
                                    </button>
                                </li> -->

                            </ul>
                            <!-- Tabs content -->
                            <div class="tab-content">
                                <div class="tab-pane fade show active" id="baseConfStep" role="tabpanel"
                                    aria-labelledby="step-1">
                                    <input type="hidden" class="form-control" name="questionSettings[page]" value="1" />
                                    <div class="row">
                                        <div class="col-12">
                                            <p class="tab-description mt-3 mb-2">
                                                {{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_1")
                                                }}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{ __("misc.title") }}</label>
                                                <input type="text" class="form-control rounded" v-model="name"
                                                    name="questionBase[name]" />
                                            </div>

                                            <div class="form-group">
                                                <label>{{ __("misc.sorting") }}</label>
                                                <input type="number" class="form-control rounded" v-model="sorting"
                                                    name="questionBase[sorting]" />
                                            </div>

                                            <div class="form-group">
                                                <label>{{ __("misc.description") }}</label>
                                                <input type="text" class="form-control rounded" v-model="description"
                                                    name="questionBase[description]" />
                                            </div>
                                            <div class="form-group">
                                                <div class="custom-control custom-switch">
                                                    <input
                                                        name="questionSettings[step_1][prepopulate_skill_levels_in_self_evaluation]"
                                                        type="checkbox" class="custom-control-input"
                                                        id="questionSettings[step_1][prepopulate_skill_levels_in_self_evaluation]"
                                                        value="1" v-model="prepopulate_skill_levels_in_self_evaluation" />
                                                    <label class="custom-control-label"
                                                        for="questionSettings[step_1][prepopulate_skill_levels_in_self_evaluation]">{{
                                                            __("forms.EvaluationChart.questions.questions_setting.question41.step_1.prepopulate_skill_levels_in_self_evaluation")}}
                                                    </label>
                                                </div>
                                            </div>
                                              <div class="form-group">
                                                <label>{{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_1.skill_typologies_included")
                                                }}</label>
                                                <table class="table">
                                                    <tbody>
                                                        <tr v-for="typology in all_typologies" :key="typology.id">
                                                            <td style="width: 30px;">
                                                                <input
                                                                    name="questionSettings[step_1][skill_typologies_included][]"
                                                                    type="checkbox"
                                                                    :value="typology.id"
                                                                    v-model="skill_typologies_included" />
                                                            </td>
                                                            <td>{{ typology.name }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="form-group">
                                                <label for="questionSettings[step_1][skill_weighting_model_id]">{{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_1.skill_weighting_model")
                                                }}</label>
                                                <select
                                                    name="questionSettings[step_1][skill_weighting_model_id]"
                                                    id="questionSettings[step_1][skill_weighting_model_id]"
                                                    class="form-control"
                                                    required
                                                    v-model="skill_weighting_model_id">
                                                    <option value="">---</option>
                                                    <option v-for="model in all_skill_weighting_models" :key="model.id" :value="model.id">{{ model.name }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <p class="font-weight-bold mb-1">{{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_1.weight_visibility_section")
                                                }}</p>
                                                <div class="custom-control custom-checkbox">
                                                    <input
                                                        name="questionSettings[step_1][show_weight_categories]"
                                                        type="checkbox" class="custom-control-input"
                                                        id="questionSettings[step_1][show_weight_categories]"
                                                        value="1" v-model="show_weight_categories" />
                                                    <label class="custom-control-label"
                                                        for="questionSettings[step_1][show_weight_categories]">{{
                                                            __("forms.EvaluationChart.questions.questions_setting.question41.step_1.show_weight_categories")
                                                        }}</label>
                                                </div>
                                                <div class="custom-control custom-checkbox mt-1">
                                                    <input
                                                        name="questionSettings[step_1][show_weight_skills]"
                                                        type="checkbox" class="custom-control-input"
                                                        id="questionSettings[step_1][show_weight_skills]"
                                                        value="1" v-model="show_weight_skills" />
                                                    <label class="custom-control-label"
                                                        for="questionSettings[step_1][show_weight_skills]">{{
                                                            __("forms.EvaluationChart.questions.questions_setting.question41.step_1.show_weight_skills")
                                                        }}</label>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label
                                                    for="questionSettings[step_1][set_min_value_avg_global_rating]">{{
                                                        __("forms.EvaluationChart.questions.questions_setting.question41.step_1.set_min_value_avg_global_rating")
                                                    }}</label>
                                                <input name="questionSettings[step_1][set_min_value_avg_global_rating]"
                                                    type="number" class="form-control"
                                                    id="questionSettings[step_1][set_min_value_avg_global_rating]"
                                                    value="1" v-model="set_min_value_avg_global_rating" />
                                            </div>
                                            <div class="form-group">
                                                <label
                                                    for="questionSettings[step_1][set_max_value_avg_global_rating]">{{
                                                        __("forms.EvaluationChart.questions.questions_setting.question41.step_1.set_max_value_avg_global_rating")
                                                    }}</label>
                                                <input name="questionSettings[step_1][set_max_value_avg_global_rating]"
                                                    type="number" class="form-control"
                                                    id="questionSettings[step_1][set_max_value_avg_global_rating]"
                                                    value="1" v-model="set_max_value_avg_global_rating" />
                                            </div>
                                          
                                        </div>
                                        <hr>
                                        <div class="col-12 mt-3 text-right" v-if="can_write">
                                            <button class="btn btn-next" @click="goToStep(2, false)" type="button">
                                                {{ __("misc.next") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="categoriesStep" role="tabpanel"
                                    aria-labelledby="categoriesStep">
                                    <input type="hidden" class="form-control" name="questionSettings[page]" value="2" />

                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_2")
                                            }}
                                        </p>
                                        <p>
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_2.description_1")
                                            }}<br>
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_2.description_2")
                                            }}
                                        </p>
                                    </div>
                                    <div class="col-12 mt-2">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[step_2][enable_category_grouping]"
                                                type="checkbox" class="custom-control-input"
                                                id="questionSettings[step_2][enable_category_grouping]" value="1"
                                                v-model="enable_category_grouping" />
                                            <label class="custom-control-label"
                                                for="questionSettings[step_2][enable_category_grouping]">{{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_2.enable_category_grouping")
                                                }}</label>
                                        </div>
                                        <hr>
                                        <div v-for="(category, index) in sortedSkillCategories" :key="category.id"
                                            class="form-group mt-3" draggable="true"
                                            @dragstart="handleDragStart($event, index)"
                                            @dragover.prevent="handleDragOver($event, index)"
                                            @dragenter.prevent="handleDragEnter($event, index)"
                                            @dragleave="handleDragLeave($event)"
                                            @drop.prevent="handleDrop($event, index)" @dragend="handleDragEnd">
                                            <div :style="{
                                                border: draggedIndex === index ? '2px dashed #4CAF50' : '1px solid #e0e0e0',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
                                                padding: '10px',
                                                cursor: 'move',
                                                opacity: draggedIndex === index ? '0.5' : '1'
                                            }">
                                                <div><label>{{ index + 1 }}</label>
                                                    &nbsp;&nbsp;
                                                    <i class="fa-solid fa-grip"></i>
                                                    &nbsp;
                                                    <input type="color"
                                                        :name="'questionSettings[step_2][skill_categories][' + category.id + '][color]'"
                                                        style=" width: 30px;height: 30px;border-radius: 50%;padding: 0px;cursor: pointer;
                                                                border: 2px solid rgb(221, 221, 221);vertical-align: middle;" 
                                                        v-model="category.color" 
                                                    />
                                                    &nbsp;
                                                    {{ category.name }}
                                                    <input type='hidden'
                                                        :name="'questionSettings[step_2][skill_categories][' + category.id + '][id]'"
                                                        :value="category.id" />
                                                    <input type='hidden'
                                                        :name="'questionSettings[step_2][skill_categories][' + category.id + '][sort]'"
                                                        :value="index" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <hr>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" @click="goToStep(1, false)" type="button">
                                            {{ __("misc.back") }}
                                        </button>
                                        <button class="btn btn-next" @click="goToStep(3, false)" type="button">
                                            {{ __("misc.next") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="historiesSkillsStep" role="tabpanel"
                                    aria-labelledby="historiesSkillsStep">
                                    <input type="hidden" class="form-control" name="questionSettings[page]" value="3" />
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_3")
                                            }}
                                        </p>
                                        <p>
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_3.description_1")
                                            }}<br>
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_3.description_2")
                                            }}
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_3.description_3")
                                            }}
                                        </p>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{{
                                                        __("forms.EvaluationChart.questions.questions_setting.question41.step_3.session")
                                                    }}</th>
                                                    <th scope="col">{{
                                                        __("forms.EvaluationChart.questions.questions_setting.question41.step_3.show_evaluation_question")
                                                    }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="session in sessions_data" :key="session.id">
                                                    <td>
                                                        <label>
                                                            {{ session.name }}
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <div v-for="question in session.question_surveys"
                                                            :key="question.id">
                                                            <input
                                                                name="questionSettings[step_3][combo_history_evaluation_session_id_history_question_survey_id]"
                                                                type="radio"
                                                                v-model="combo_history_evaluation_session_id_history_question_survey_id"
                                                                :value="session.id + '_' + question.id" />
                                                            <label>
                                                                {{ question.name }} ( {{ question.question_name }} )
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <input
                                                            name="questionSettings[step_3][combo_history_evaluation_session_id_history_question_survey_id]"
                                                            type="radio" value=""
                                                            v-model="combo_history_evaluation_session_id_history_question_survey_id" />
                                                        <label>
                                                            {{
                                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_3.no_show_history_session")
                                                            }}
                                                        </label>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">

                                        <button class="btn btn-next" @click="goToStep(2, false)" type="button">
                                            {{ __("misc.back") }}
                                        </button>
                                        <button class="btn btn-next" @click="goToStep(4, false)" type="button">
                                            {{ __("misc.next") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="levelsStep" role="tabpanel" aria-labelledby="levelsStep">
                                    <input type="hidden" class="form-control" name="questionSettings[page]" value="4" />
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.steps.step_4")
                                            }}
                                        </p>
                                        <p>
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.description_1")
                                            }}
                                        </p>

                                        <div class="selection-level">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 30px;">{{
                                                            __("forms.EvaluationChart.questions.questions_setting.question41.step_4.use_level")
                                                            }}</th>
                                                        <th style="width: 150px;">
                                                            <strong>{{
                                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.level")
                                                            }}</strong>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <strong>{{
                                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.weight")
                                                            }}</strong>
                                                        </th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="skillLevel in all_levels" :key="skillLevel.id">
                                                        <td>
                                                            <input
                                                                name="questionSettings[step_4][skill_levels_selected][]"
                                                                type="checkbox" :value="skillLevel.id"
                                                                v-model="skill_levels_selected" />
                                                        </td>
                                                        <td>{{ skillLevel.name }}</td>
                                                        <td>{{ skillLevel.weight }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <hr>
                                            <label>{{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.include_not_evaluable_level")
                                                }}</label>
                                            <div class="d-flex mr-2">
                                                <div class="custom-control custom-switch mr-3">
                                                    <input
                                                        name="questionSettings[step_4][show_level_not_evaluable_for_evaluation]"
                                                        type="checkbox" class="custom-control-input"
                                                        id="questionSettings[step_4][show_level_not_evaluable_for_evaluation]"
                                                        value="1" v-model="show_level_not_evaluable_for_evaluation" />
                                                    <label class="custom-control-label"
                                                        for="questionSettings[step_4][show_level_not_evaluable_for_evaluation]">{{
                                                            __("forms.EvaluationChart.questions.questions_setting.question41.step_4.show_level_not_evaluable_for_evaluation")
                                                        }}</label>
                                                </div>
                                                <div class="custom-control custom-switch">
                                                    <input
                                                        name="questionSettings[step_4][show_level_not_evaluable_for_self_evaluation]"
                                                        type="checkbox" class="custom-control-input"
                                                        id="questionSettings[step_4][show_level_not_evaluable_for_self_evaluation]"
                                                        value="1"
                                                        v-model="show_level_not_evaluable_for_self_evaluation" />
                                                    <label class="custom-control-label"
                                                        for="questionSettings[step_4][show_level_not_evaluable_for_self_evaluation]">{{
                                                            __("forms.EvaluationChart.questions.questions_setting.question41.step_4.show_level_not_evaluable_for_self_evaluation")
                                                        }}</label>
                                                </div>
                                            </div>
                                            <div class='alert alert-warning'>
                                                <i class='fas fa-exclamation-triangle'></i>
                                                {{ __("forms.EvaluationChart.questions.questions_setting.question41.step_4.not_evaluable_explanation") }}
                                            </div>
                                        </div>
                                        <hr>
                                        <!-- Delta -->
                                        <p class="tab-description mt-3 mb-2">
                                            {{
                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.description_2")
                                            }}
                                        </p>
                                        <div>
                                            <!-- Create -->
                                            <div class=form-group>
                                                <label>{{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_4.new_delta_value")
                                                    }}</label>
                                                <input class='form-control' type="number" v-model="new_delta_value" />
                                            </div>
                                            <div class=form-group>
                                                <label>{{
                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_4.color")
                                                    }}</label>
                                                <input
                                                    style=" 
                                                        width: 30px;height: 30px;border-radius: 50%;padding: 0px;cursor: pointer;
                                                        border: 2px solid rgb(221, 221, 221);vertical-align: middle;"         
                                                    type="color" 
                                                    class="form-control" 
                                                    v-model="new_delta_color" />
                                            </div>
                                            <button class="btn btn-primary mt-2" type="button" @click="addDelta()">
                                                {{ __("misc.add") }}
                                            </button>
                                        </div>
                                        <div>
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th><!-- Space for trash button --></th>
                                                        <th>
                                                            <strong>
                                                                {{
                                                                    __("forms.EvaluationChart.questions.questions_setting.question41.step_4.delta")
                                                                }}
                                                            </strong>
                                                        </th>
                                                        <th>
                                                            <strong>{{
                                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.delta_legend")
                                                            }}</strong>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <!-- Not evaluable row -->
                                                    <tr>
                                                        <td>
                                                            <!-- <a href="#" style='arrow' disabled > <i class="fas fa-trash"></i> </a> -->
                                                        </td>
                                                        <td>
                                                            {{
                                                                __("forms.EvaluationChart.questions.questions_setting.question41.step_4.not_evaluable_level")
                                                            }}
                                                        </td>
                                                        <td>
                                                            <input
                                                                style="width: 30px; height: 30px; border-radius: 50%; padding: 0; cursor: pointer; border: 2px solid #ddd; vertical-align: middle;"
                                                                :name="'questionSettings[step_4][not_evaluable_delta_color]'"
                                                                type="color" class="form-control"
                                                                :value="not_evaluable_delta_color" />
                                                        </td>
                                                    </tr>
                                                    <!-- Other levels row -->
                                                    <tr v-for="(delta, index) in deltas" :key="index">
                                                        <td>
                                                            <a href="#" @click.prevent="removeDelta(index)">
                                                                <i class="fas fa-trash" style='color:red'></i>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <input
                                                                :name="'questionSettings[step_4][deltas][' + index + '][delta_value]'"
                                                                type="number" v-model="delta.delta_value"
                                                                class="form-control" />
                                                        </td>
                                                        <td>
                                                            <input
                                                                :name="'questionSettings[step_4][deltas][' + index + '][color]'"
                                                                type="color" v-model="delta.color" class="form-control"
                                                                style=" width: 30px;height: 30px;border-radius: 50%;padding: 0px;cursor: pointer;
                                                                        border: 2px solid rgb(221, 221, 221);vertical-align: middle;" 
                                                                />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">

                                        <button class="btn btn-next" @click="goToStep(3, false)" type="button">
                                            {{ __("misc.back") }}
                                        </button>
                                        <!-- <button class="btn btn-next" @click="goToStep(5, false)" type="button"> -->
                                        <button type="button" class="btn btn-next" @click="goToStep(4, true)">
                                            {{ __("misc.save") }}
                                        </button>
                                    </div>
                                </div>

                                <!-- <div class="tab-pane fade" id="slideModeStep" role="tabpanel"
                                    aria-labelledby="slideModeStep">
                                    <input type="hidden" class="form-control" name="questionSettings[page]" value="5" />
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <div> EEEE </div>
                                        <button class="btn btn-next" @click="goToStep(4, false)" type="button">
                                            {{ __("misc.back") }}
                                        </button>
                                        <button type="button" class="btn btn-next" @click="goToStep(5, true)">
                                            {{ __("misc.save") }}
                                        </button>
                                    </div>
                                </div> -->

                            </div>
                            <!-- End tabs content -->
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import { Button } from 'bootstrap';

export default {

    props: {
        can_write: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            textQuestion: '',
            //default
            title: this.__('forms.EvaluationChart.questions.questions_setting.question41.title'),
            active: false,
            action: "",
            name: "",
            description: "",
            sorting: -1,
            editing: true,
            oldStep: 1,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            //Form Params
            //STEP 1
            prepopulate_skill_levels_in_self_evaluation: false,
            set_min_value_avg_global_rating: -1,
            set_max_value_avg_global_rating: -1,
            all_typologies: [],
            skill_typologies_included: [],
            all_skill_weighting_models: [],
            skill_weighting_model_id: '',
            show_weight_categories: false,
            show_weight_skills: false,
            //STEP 2
            enable_category_grouping: false,
            skill_categories: [],
            categories_data: [],
            draggedIndex: null,
            //STEP 3
            combo_history_evaluation_session_id_history_question_survey_id: null,
            sessions_data: [],
            //STEP 4
            all_levels: [],
            show_level_not_evaluable_for_evaluation: false,
            show_level_not_evaluable_for_self_evaluation: false,
            skill_levels_selected: [],
            deltas: [],
            not_evaluable_delta_color: '#000000',
            new_delta_color: '#FFFFFF',
            new_delta_value: 0,
        }
    },
    computed: {
        sortedSkillCategories() {
            return [...this.skill_categories].sort((a, b) => {
                const sortA = a.sort !== undefined ? a.sort : 0;
                const sortB = b.sort !== undefined ? b.sort : 0;
                return sortA - sortB;
            });
        }
    },
    methods: {

        addDelta() {
            this.deltas.push({ delta_value: this.new_delta_value, color: this.new_delta_color });
            this.new_delta_value = 0;
            this.new_delta_color = '#FFFFFF';
        },
        removeDelta(index) {
            this.deltas.splice(index, 1);
        },
        handleDragStart(event, index) {
            this.draggedIndex = index;
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/html', event.target);
        },
        handleDragEnter(event, index) {
            if (this.draggedIndex !== index) {
                event.target.style.borderColor = '#4CAF50';
            }
        },
        handleDragLeave(event) {
            event.target.style.borderColor = '#e0e0e0';
        },
        handleDragOver(event, index) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
            return false;
        },
        handleDrop(event, dropIndex) {
            event.preventDefault();
            event.stopPropagation();

            if (this.draggedIndex === null || this.draggedIndex === dropIndex) return false;

            const sortedCategories = [...this.sortedSkillCategories];
            const draggedItem = sortedCategories[this.draggedIndex];

            // Rimuovi l'elemento dalla posizione originale
            sortedCategories.splice(this.draggedIndex, 1);
            // Inseriscilo nella nuova posizione
            sortedCategories.splice(dropIndex, 0, draggedItem);

            // Aggiorna i valori sort in base al nuovo ordine
            sortedCategories.forEach((cat, idx) => {
                const originalCat = this.skill_categories.find(c => c.id === cat.id);
                if (originalCat) {
                    this.$set(originalCat, 'sort', idx);
                }
            });

            // Forza il re-render
            this.$forceUpdate();

            return false;
        },
        handleDragEnd(event) {
            this.draggedIndex = null;
            // Reset border color only for form groups inside this form
            const elements = document.querySelectorAll('#question41Form .form-group');
            elements.forEach(el => {
                el.style.borderColor = '#e0e0e0';
            });
        },
        updateOldStep(stepId) {
            this.oldStep = stepId;
        },
        goToStep(stepId, reloadPage) {

            let formDataSerialized = $("#question41Form").serialize();
            let route = $("#question41Form").attr("action");

            axios.put(route,
                {
                    questionBase: {
                        name: this.name,
                        description: this.description,
                        sorting: this.sorting
                    },
                    questionSettings: {
                        gridSkillsData: formDataSerialized,
                        oldStep: this.oldStep
                    },

                }
            ).then(function (response) {
                if (reloadPage) {
                    location.reload();
                } else {
                    $("#step-" + stepId).trigger("click");
                }

            }).catch(function (error) {
                console.error("NO", error);
            });
            this.updateOldStep(stepId);
        },

        toggle(action, item_id, editing, attributes) {
            this.active = true;
            this.action = action;
            this.editing = editing;

            let dataRoute = decodeURI(attributes.dataRoute);
            if (dataRoute !== undefined) {
                if (dataRoute.indexOf("[id]") > 0) {
                    dataRoute = dataRoute.replace("[id]", item_id);

                }

                let svc = this;

                axios.get(dataRoute)
                    .then((response) => {
                        svc.name = response.data.base.name;
                        svc.description = response.data.base.description;
                        svc.sorting = response.data.base.sorting;
                        svc.can_write = app.__vue__.questionPermission(svc.can_write, response.data.base.enable);

                        //STEP 1
                        svc.prepopulate_skill_levels_in_self_evaluation = response.data.settings.step_1.prepopulate_skill_levels_in_self_evaluation;
                        svc.set_min_value_avg_global_rating = response.data.settings.step_1.set_min_value_avg_global_rating;
                        svc.set_max_value_avg_global_rating = response.data.settings.step_1.set_max_value_avg_global_rating;
                        svc.all_typologies = response.data.settings.step_1.all_typologies;
                        svc.skill_typologies_included = response.data.settings.step_1.skill_typologies_included;
                        svc.all_skill_weighting_models = response.data.settings.step_1.all_skill_weighting_models;
                        svc.skill_weighting_model_id = response.data.settings.step_1.skill_weighting_model_id ?? '';
                        svc.show_weight_categories = response.data.settings.step_1.show_weight_categories;
                        svc.show_weight_skills = response.data.settings.step_1.show_weight_skills;

                        //STEP 2
                        svc.enable_category_grouping = response.data.settings.step_2.enable_category_grouping;
                        svc.skill_categories = response.data.settings.step_2.skill_categories;

                        //STEP 3
                        svc.sessions_data = response.data.settings.step_3.sessions_data;
                        svc.combo_history_evaluation_session_id_history_question_survey_id = response.data.settings.step_3.combo_history_evaluation_session_id_history_question_survey_id;

                        //STEP 4
                        //Levels
                        svc.show_level_not_evaluable_for_evaluation = response.data.settings.step_4.show_level_not_evaluable_for_evaluation;
                        svc.show_level_not_evaluable_for_self_evaluation = response.data.settings.step_4.show_level_not_evaluable_for_self_evaluation;
                        svc.all_levels = response.data.settings.step_4.all_levels;
                        svc.skill_levels_selected = response.data.settings.step_4.skill_levels_selected;

                        //Delta
                        svc.deltas = response.data.settings.step_4.deltas;
                        svc.not_evaluable_delta_color = response.data.settings.step_4.not_evaluable_delta_color;

                    });
            }
        }

    }

}
</script>
